import { el } from 'redom';

import { stringToSVG } from 'utilities';

import spinnerUpSVGString from 'assets/images/number-spinner-up.svg?raw';
import spinnerDownSVGString from 'assets/images/number-spinner-down.svg?raw';

import { parseCSSNumberValue } from './utilities';

import './index.scss';

const spinnerUpIcon = stringToSVG(spinnerUpSVGString);
const spinnerDownIcon = stringToSVG(spinnerDownSVGString);

class CSSNumberValueControl {

  constructor(configuration) {

    this.value = configuration.value;
    this.onChange = configuration.onChange;

    this.input = el('input.css-number-value-control', {
      value: this.value,
      placeholder: configuration.placeholder || '',
      oninput: this.handleValueChange.bind(this),
      onkeydown: this.handleKeyDownEvent.bind(this)
    });

    const spinnerUp = el('button.css-number-value-spinner.css-number-value-spinner-up', {
      tabIndex: -1,
      onmousedown: this.handleSpinnerUp.bind(this)
    }, [spinnerUpIcon.cloneNode(true)]);

    const spinnerDown = el('button.css-number-value-spinner', {
      tabIndex: -1,
      onmousedown: this.handleSpinnerDown.bind(this)
    }, [spinnerDownIcon.cloneNode(true)]);

    this.el = el('.css-number-value-control-main', [
      this.input,
      el('.css-number-value-spinners', [spinnerUp, spinnerDown])
    ]);

  }

  handleValueChange(event) {

    const value = event.target.value;
    const result = parseCSSNumberValue(value);

    let _value = value;

    if (value.indexOf(result.unit) !== -1) {
      _value = _value.substring(0, _value.indexOf(result.unit) + result.unit.length);
    } else if (value.indexOf('auto') === 0) {
      _value = 'auto';
    }

    this.input.value = _value;
    this.onChange(result.validValue);

  }

  incrementValue(direction) {

    const result = parseCSSNumberValue(this.input.value);

    if (result.validValue === 'auto') {
      return;
    }

    const newNumber = result.number + direction;

    let _value = newNumber + '';

    if (this.input.value.indexOf(result.unit) !== -1) {
      _value += result.unit;
    }

    this.input.value = _value;
    this.onChange(parseCSSNumberValue(this.input.value).validValue);

  }

  handleSpinnerUp(event) {

    event.preventDefault();
    this.incrementValue(1);

  }

  handleSpinnerDown(event) {

    event.preventDefault();
    this.incrementValue(-1);

  }

  handleKeyDownEvent(event) {

    const key = event.key;
    const shiftKey = event.shiftKey;

    if (key !== 'ArrowUp' && key !== 'ArrowDown') {
      return;
    }

    const direction = key === 'ArrowUp' ? 1 : -1;
    const multiplier = shiftKey === true ? 10 : 1;

    this.incrementValue(direction * multiplier);

  }

  focus() {

    this.input.focus();

  }

}

export default CSSNumberValueControl;
